/**
 * Stable layer id scheme for operational / account maps: `{key}:{entityId}`.
 * The map provider does not interpret keys; callers use helpers to stay consistent.
 */

export const OPERATIONAL_MAP_LAYER_KEYS = [
  'path',
  /** Canvas point cloud for track history vertices (below HTML markers). */
  'path-vertices',
  /** Per-device raw decoded polylines (debug / compare to convoy). */
  'raw-path',
  /** Point cloud for raw device track pings. */
  'raw-path-vertices',
  'current-position',
  'stops',
  /** Stop boundary polygons from API `stops[].geojson` (merged into one map layer). */
  'stop-geojson',
  'corridor',
  'route',
  'exceptions',
] as const

export type OperationalMapLayerKey = (typeof OPERATIONAL_MAP_LAYER_KEYS)[number]

export function operationalMapLayerId(
  key: OperationalMapLayerKey,
  entityId: string | number,
): string {
  return `${key}:${String(entityId)}`
}

export function parseOperationalMapLayerId(id: string): {
  key: OperationalMapLayerKey | null
  entityId: string
} {
  const i = id.indexOf(':')
  if (i <= 0) {
    return { key: null, entityId: id }
  }
  const k = id.slice(0, i)
  const entityId = id.slice(i + 1)
  if ((OPERATIONAL_MAP_LAYER_KEYS as readonly string[]).includes(k)) {
    return { key: k as OperationalMapLayerKey, entityId }
  }
  return { key: null, entityId }
}
